<template>
    <div class="ReaderDemo pa-3">
        Please visit <a href="https://reader.fpt.ai" target="_blank">https://reader.fpt.ai</a>
    </div>
</template>

<script>
export default {
    name: 'ReaderDemo'
}
</script>

<style scoped lang="scss">

</style>
